import { useState } from 'react';

export function useRadioState(initialState = false) {
  const [value, setValue] = useState(initialState);

  const handler = e => {
    setValue(e.target.value);
  };

  return [value, handler];
};

export function useCheckState(initialState = false) {
  const [checked, setChecked] = useState(initialState);
  const handler = () => {
    setChecked(!checked)
  };

  return [checked, handler];
};